<div class="html-container">
  <span [innerHTML]="value || '-' | iconReplace"></span>
</div>
